<template>
  <div>
    <form
      v-if="!downloaded"
      FormHash="33900-0tsspvmeuw1njquvagw5"
      action="https://r3.minicrm.hu/Api/Signup"
      method="post"
      class="TurnKeyCRM primary color-white px-7 mt-md-5 mt-lg-0"
    >
      <div class="form-title text-center py-6">PMU DERMATOLOGY EBOOK</div>
      <div class="InputBlock">
        <input
          class="input-field"
          name="Contact[1938][LastName]"
          id="Contact_LastName_1938"
          language="EN"
          placeholder="Last name:"
          type="text"
        />
      </div>
      <div class="InputBlock">
        <input
          placeholder="First Name:"
          class="input-field"
          name="Contact[1938][FirstName]"
          id="Contact_FirstName_1938"
          language="EN"
          type="text"
        />
      </div>

      <div class="InputBlock">
        <input
          placeholder="E-mail address:"
          language="EN"
          class="input-field"
          name="Contact[1938][Email]"
          id="Contact_Email_1938"
          type="text"
        />
      </div>

      <div class="InputBlock">
        <input
          language="EN"
          class="input-field"
          placeholder="Phone number:"
          name="Contact[1938][Phone]"
          id="Contact_Phone_1938"
          type="text"
        />
      </div>

      <div>
        <label class="SetLabel">
          <span class="OverflowEllipsis pr-2">Are you a PMU artist?</span>
          <div class="select-cont">
            <select
              name="Project[1936][AreAPmuArtist]"
              id="Project_AreAPmuArtist_1936"
              language="EN"
            >
              <option selected value="">Choose answer</option>
              <option value="3101">Yes</option>
              <option value="3102">No</option>
              <option value="3113"
                >No but I would like to become a PMU artist</option
              >
            </select>
          </div>
        </label>
      </div>
      <div>
        <label class="SetLabel">
          <span class="OverflowEllipsis pr-2"
            >Would you pay for PMU Trainings?</span
          >
          <div class="select-cont">
            <select
              name="Project[1936][WouldYouPayForPmuTrainings]"
              id="Project_WouldYouPayForPmuTrainings_1936"
              language="EN"
            >
              <option selected value="">Choose answer</option>
              <option value="3111">No thanks!</option>
              <option value="3106"
                >Yes! Interested in classroom courses in Budapest</option
              >
              <option value="3105">Yes! Interested in online courses</option>
            </select>
          </div>
        </label>
      </div>
      <div class="InputBlock mt-4">
        <label class="SetLabel">
          <div class="input-cont">
            <input
              id="Dummy_GDPR_Contribution__0"
              type="checkbox"
              value="1"
              name="Dummy[][GDPR_Contribution][]"
            />
            <span class="checkmark"></span>
          </div>
          <span class="OverflowEllipsis CheckBoxLabel"
            >I consent to the processing of my data in the
            <a style="color: white;" href="https://www.minicrm.hu/gdpr/" target="_blank">
              CRM system
            </a>
            of Méhn Tünde Esthetic Line Kft.</span
          >
        </label>
      </div>

      <div
        ref="response"
        :id="responseId"
        style="display: none"
        class="Response"
      >
        <slot />
      </div>
      <input
        v-show="!downloaded"
        id="Submit_33900-0tsspvmeuw1njquvagw5"
        type="Submit"
        class="submit"
        value="I want it"
        @click="send"
      />
    </form>
    <div
      v-else
      class="thank-you pa-10 white primary--text flex-column text-left"
      style="border-radius: 40px"
    >
      <h3>Thank You</h3>
      <div class="pt-5">
        The free e-book will soon arrive to your inbox. Please check your spam
        folder as well. If the e-mail does not arrive in 15 minutes, then please
        e-mail us on <strong>info@mehntunde.hu</strong> !
      </div>
      <div
        @click.stop="goAway"
        class="back-to-home primary white--text d-inline-flex py-3 px-5 mt-10 font-weight-bold"
        style="border-radius: 20px"
      >
        GO TO MAIN PAGE
      </div>
    </div>
  </div>
</template>

<script>
/* Helper function */
function download_file(fileURL, fileName) {
  // for non-IE
  if (!window.ActiveXObject) {
    var save = document.createElement("a");
    save.href = fileURL;
    save.target = "_blank";
    var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
    save.download = fileName || filename;
    if (
      navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
      navigator.userAgent.search("Chrome") < 0
    ) {
      document.location = save.href;
      // window event not working here
    } else {
      var evt = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false
      });
      save.dispatchEvent(evt);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }
  }

  // for IE < 11
  else if (!!window.ActiveXObject && document.execCommand) {
    var _window = window.open(fileURL, "_blank");
    _window.document.close();
    _window.document.execCommand("SaveAs", true, fileName || fileURL);
    _window.close();
  }
}

const goToPdf = () => {
  const url = "https://rosaherbal.com/wp-content/uploads/ebook.pdf";
  download_file(url, "https://rosaherbal.com/wp-content/uploads/ebook.pdf");
};

export default {
  name: "FormComponent",

  data: () => ({
    responseId: "Response_33900-0tsspvmeuw1njquvagw5",
    downloaded: false
  }),
  methods: {
    send() {
      let interval = setInterval(() => {
        const res = this.$refs.response.innerText.toLowerCase();

        if (res.indexOf("successfully") >= 0 || res.indexOf("siker") >= 0) {
          clearInterval(interval);
        }

        if (res.indexOf("successfully") >= 0 || res.indexOf("siker") >= 0) {
          clearInterval(interval);
          goToPdf();
          this.downloaded = true;
        }
      }, 200);

      setTimeout(() => {
        clearInterval(interval);
        // goToPdf();
      }, 2500);
    },
    goAway() {
      window.location.href = "https://rosaherbal.com";
    }
  }
};
</script>
<style lang="scss">
:root {
  --select-border: #777;
  --select-focus: blue;
  --select-arrow: var(--select-border);
}

.thank-you {
  @media (max-width: 680px) {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}

form {
  border-radius: 40px;
  color: #fff;

  @media (max-width: 680px) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .submit,
  .back-to-home {
    cursor: pointer;
    background: white;
    border-radius: 11px;
    padding: 5px 30px;
    margin-top: 20px;
    color: #505050;
    font-weight: 500;
    margin: 10px auto;
    letter-spacing: 0.09em;
    box-shadow: 2px 3px 8px 0px rgba(0, 0, 0, 0.6);
  }

  .SetLabel {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-top: 10px;
    position: relative;

    > span {
      order: 1;
      padding-left: 4px;
      padding-right: 50px;
      text-align: left;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 21px;
      letter-spacing: 0.06em;
      display: block;
    }

    .select-cont {
      order: 2;
      color: rgba(0, 0, 0, 0.7);
      position: relative;

      select {
        width: 100%;
        min-width: 10ch;
        max-width: 30ch;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.5);
        padding: 8px;
        cursor: pointer;
        line-height: 1.1;
        padding-right: 25px;
      }
      &:after {
        position: absolute;
        pointer-events: none;
        top: 13px;
        right: 10px;
        content: "";
        width: 0.8em;
        height: 0.5em;
        background-color: var(--select-arrow);
        clip-path: polygon(100% 0%, 0 0%, 50% 100%);
      }
    }

    .input-cont {
      order: 2;
      position: absolute;
      width: 22px;
      height: 22px;
      right: 0;
      top: 0;

      input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;

        &:checked ~ span {
          &:after {
            content: "";
            position: absolute;
            left: 8px;
            top: 5px;
            width: 6px;
            height: 11px;
            border: solid rgba(0, 0, 0, 0.7);
            border-width: 0 3px 3px 0;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
          }
        }
      }

      > span {
        position: absolute;
        top: 0;
        left: 0;
        width: 22px;
        height: 22px;
        border-radius: 7px;
        background: rgba(255, 255, 255, 0.5);
      }
    }
  }

  legend {
    color: #fff;
  }

  label {
    color: #fff;
  }

  .form-title {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0.045em;
  }

  .input-field {
    width: 100%;
    margin-top: 10px;
    padding: 12px 10px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0.045em;
    color: rgba(0, 0, 0, 0.7);

    &::-webkit-input-placeholder {
      /* Edge */
      color: rgba(0, 0, 0, 0.7);
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(0, 0, 0, 0.7);
    }

    &::placeholder {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
